export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/60 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/50 blur-3xl"></div>
        <div className="absolute top-1/3 left-1/4 w-[300px] h-[300px] rounded-full bg-secondary-100/40 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              2026夏季新番热播中
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              樱花动漫<span className="text-primary-500"> · </span>追更动漫之家
            </h1>

            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-5 max-w-xl mx-auto lg:mx-0">
              你身边的追更动漫伙伴——第一时间追踪连载动漫更新，最新动漫新番在线看，热门新番推荐一网打尽。无论你是追热血战斗还是温馨日常，樱花动漫之家都为你整理好追更日程，让你不错过每一集精彩。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">50+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新番剧</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">12类</div>
                <div className="text-xs text-foreground-500 mt-1">番剧分类覆盖</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">7×24</div>
                <div className="text-xs text-foreground-500 mt-1">追更不停歇</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看新番热度榜
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-800 rounded-full font-medium text-sm hover:bg-background-200 transition-colors border border-background-300/60 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索追更专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/70">
                <img
                  src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20anime%20illustration%20collage%20featuring%20diverse%20anime%20characters%20in%20dynamic%20poses%20with%20cherry%20blossom%20petals%20falling%2C%20warm%20cinematic%20lighting%2C%20sakura%20trees%20in%20background%2C%20soft%20dreamy%20atmosphere%2C%20anime%20streaming%20platform%20vibe%2C%20clean%20modern%20aesthetic%2C%20rich%20saturated%20colors%20with%20pink%20and%20golden%20tones%2C%20no%20text%20or%20watermarks&width=1200&height=900&seq=hero-anime-2026&orientation=landscape"
                  alt="樱花动漫追更 - 热门新番动漫角色插画合集"
                  className="w-full h-auto object-cover aspect-[4/3]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
              </div>
              <div className="absolute -bottom-3 -right-3 bg-background-50 rounded-xl px-4 py-2.5 border border-background-200/70 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                <span className="text-xs text-foreground-700 font-medium whitespace-nowrap">今日已更新 28 部</span>
              </div>
              <div className="absolute -top-3 -left-3 bg-accent-500 text-background-50 rounded-xl px-4 py-2.5 flex items-center gap-2">
                <i className="ri-sparkling-line"></i>
                <span className="text-xs font-medium whitespace-nowrap">2026夏季新番上线</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}